import { gql } from "@apollo/client";

export const GET_ALL_WORK_GROUP_BY_MANDATE = gql`
    query GetAllWorkGroupByMandate {
        getAllWorkGroupByMandate {
            _id
            numbering
            work_group_name
            responsibilities
            summary_info {
                total_group_member
                total_group_member_as_female
                total_council_member
                total_council_member_as_female
                total_secretary_member
                total_secretary_member_as_female
            }
        }
    }
`;

export const GET_WORK_GROUP_BY_ID = gql`
    query GetWorkGroupById($id: ID!) {
        getWorkGroupById(_id: $id) {
            _id
            numbering
            work_group_name
            responsibilities
            provincial_council {
                provincialCouncilInMandateId
                firstNameKh
                lastNameKh
                latinName
                roleInWorkGroup
            }
            secretary {
                secretaryInMandateId
                firstNameKh
                lastNameKh
                latinName
                roleInWorkGroup
            }
        }
    }
`;

export const GET_NEXT_NUMBERING = gql`
    query Query {
        getNextNumberingWorkGroup
    }
`;

export const CREATE_WORK_GROUP = gql`
    mutation CreateWorkGroup($input: WorkGroupInput!) {
        createWorkGroup(input: $input) {
            isSuccess
            message {
                messageKh
                messageEn
            }
        }
    }
`;

export const UPDATE_WORK_GROUP = gql`
    mutation UpdateWorkGroup($id: ID!, $input: WorkGroupInput!) {
        updateWorkGroup(_id: $id, input: $input) {
            isSuccess
            message {
            messageKh
            messageEn
            }
        }
    }
`;

export const DELETE_WORK_GROUP = gql`
    mutation DeleteWorkGroup($id: ID!) {
        deleteWorkGroup(_id: $id) {
            isSuccess
            message {
            messageKh
            messageEn
            }
        }
    }
`;